<ng-container *transloco="let t">
  <div class="order-section-item">
    <div class="order-section-item-title">{{ t('orderDetails.billingVatCondition') }}</div>
    <div class="order-section-item-value">{{ vatCondition() }}</div>
  </div>
  <div class="order-section-item">
    <div class="order-section-item-title">{{ t('orderDetails.billingName') }}</div>
    <div class="order-section-item-value">{{ billingName() }}</div>
  </div>
  <div class="order-section-item">
    <div class="order-section-item-title">{{ t('orderDetails.billingDocument') }}</div>
    <div class="order-section-item-value">
      {{ billingDocument() }}
    </div>
  </div>
  <div class="order-section-item">
    <div class="order-section-item-title">
      {{
        isVatConditionBusiness()
          ? t('orderDetails.billingBusinessAddress')
          : t('orderDetails.billingAddress')
      }}
    </div>
    <div class="order-section-item-value">{{ billingAddress() }}</div>
  </div>
  <div class="order-section-item">
    <div class="order-section-item-title">
      {{ t('orderDetails.billingEmail') }}
    </div>
    <div class="order-section-item-value">{{ billingEmail() }}</div>
  </div>
</ng-container>
